export const Mutation = {
    CREATE_ORDER_REFERENCE      : 'CREATE_ORDER_REFERENCE',
    CREATE_HISTORY              : 'CREATE_HISTORY',
    CREATE_DECOMPOSED_HISTORY   : 'CREATE_DECOMPOSED_HISTORY',
    CREATE_ORDER_STATE          : 'CREATE_ORDER_STATE',

    CREATE_ACTIVE_MODAL         : 'CREATE_ACTIVE_MODAL',
    UPDATE_ACTIVE_MODAL         : 'UPDATE_ACTIVE_MODAL',
    DELETE_ACTIVE_MODAL         : 'DELETE_ACTIVE_MODAL',

    CREATE_KANBAN               : 'CREATE_KANBAN',

    CREATE_KANBAN_ORDER_REFERENCE: 'CREATE_KANBAN_ORDER_REFERENCE',
    UPDATE_KANBAN_ORDER_REFERENCE: 'UPDATE_KANBAN_ORDER_REFERENCE',
    DELETE_KANBAN_ORDER_REFERENCE: 'DELETE_KANBAN_ORDER_REFERENCE',
    ORDER_KANBAN_ORDER_REFERENCES: 'ORDER_KANBAN_ORDER_REFERENCES',

    CREATE_KANBAN_PENDING_LIST  : 'CREATE_KANBAN_PENDING_LIST',

    CREATE_CALENDAR             : 'CREATE_CALENDAR',

    ADD_CALENDAR_EVENTS         : 'ADD_CALENDAR_EVENTS',
    CREATE_CALENDAR_EVENT       : 'CREATE_CALENDAR_EVENTS',
    UPDATE_CALENDAR_EVENT       : 'UPDATE_CALENDAR_EVENTS',
    DELETE_CALENDAR_EVENT       : 'DELETE_CALENDAR_EVENTS',
    DELETE_ALL_CALENDAR_EVENTS  : 'DELETE_ALL_CALENDAR_EVENTS',
    DELETE_ORDER_REFERENCE_CALENDAR_EVENTS: 'DELETE_ORDER_REFERENCE_CALENDAR_EVENTS',

    CREATE_FILTER               : 'CREATE_FILTER',
    UPDATE_FILTER               : 'UPDATE_FILTER',
    DELETE_FILTER               : 'DELETE_FILTER',

    SET_LAST_UPDATE_TIME        : 'SET_LAST_UPDATE_TIME',
    SET_QUEUE_EDIT_ACTIVE       : 'SET_QUEUE_EDIT_ACTIVE',

    SET_SHOW_KANBAN_CONTAINER_OVERLAY: 'SET_SHOW_KANBAN_CONTAINER_OVERLAY',

    SET_IS_MENU_SHOWING         : 'SET_IS_MENU_SHOWING',
}
